import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DrowpdownFilterHandler } from '../../../utils/utils';
import { filter } from 'rxjs/operators';
import * as moment from 'moment';
import { ResearchPortalBdService } from '../../../services/research-portal-bd.service';

@Component({
  selector: 'app-stocks',
  templateUrl: './stocks.component.html',
  styleUrls: ['./stocks.component.scss'],
})
export class StocksComponent implements OnInit {
  companyListMaster;
  companyList = [];
  selectedCompany = null;
  sharePriceDetails = null;
  activeRightSide = true;
  secCActiveTab = 'rsi';
  secDActiveTab = 'ratio';
  graphDataSet = null;
  darkMode = false;
  chartIndexTypesMaster;
  selectedDuration = '1M';
  fromDate = null;
  toDate = new Date();
  handleCompanyFilter = DrowpdownFilterHandler.bind(this)('companyListMaster', 'companyList', 'companyName');
  sharepriceInfoInProgress: boolean;

  selectedCompanyId = null;
  priceChange = null;
  priceChangePercentage = null;
  overviewData = null;
  loadingOverview = false;
  currentUser = null;
  isPermitted = null;
  constructor(
    private researchPortalService: ResearchPortalBdService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
      this.handleRouteChange(e.url);
    });
  }
  handleRouteChange(url: string) {
    this.activeRightSide = url.includes('overview');
    console.log('Active Right Side: ' + this.activeRightSide);
    this.cdRef.detectChanges();
  }
  async ngOnInit() {
    this.handleRouteChange(this.router.url);
    if (this.route.snapshot.queryParams && this.route.snapshot.queryParams?.id) {
      this.selectedCompanyId = this.route.snapshot.queryParams?.id;

      let co = this.companyList.find((company) => company['stocks'][0].code.toString() === this.selectedCompanyId.toString());
      this.selectedCompany = co ? co : this.companyList[0];
    }

    this.durationChanged('1M');
    this.companyListMaster = await this.researchPortalService.getCompanies();

    this.companyList = [...this.companyListMaster];
    if (this.selectedCompanyId) {
      let co = this.companyList.find((company) => company.companyName.toString() === this.selectedCompanyId.toString());
      this.selectedCompany = co ? co : this.companyList[0];
    } else {
      this.selectedCompany = this.companyList.length > 0 ? this.companyList[0] : null;
    }
    this.researchPortalService.emit(this.selectedCompany);
    await this.getSharePrice(this.selectedCompany.companyName);
    await this.setOverviewDateOnLoad();
    this.cdRef.detectChanges();
  }

  async getSharePrice(companyId) {
    this.sharePriceDetails = null;
    try {
      this.sharepriceInfoInProgress = true;
      this.sharePriceDetails = await this.researchPortalService.getTickerData(companyId);
      this.sharepriceInfoInProgress = false;
      this.cdRef.detectChanges();
    } catch (e) {
      this.sharepriceInfoInProgress = false;
    }
  }

  async setOverviewDateOnLoad() {
    this.overviewData = null;
    this.loadingOverview = true;
    this.cdRef.detectChanges();
    try {
      this.overviewData = await this.researchPortalService.getCompanySummary(this.selectedCompany.companyName);
      this.loadingOverview = false;
      this.cdRef.detectChanges();
    } catch (e) {
      console.log(e);
    }
  }

  activeTab = (activeTab, tab) => {
    this[activeTab] = tab;
  };

  public async selectionChange(value: any): Promise<void> {
    this.researchPortalService.emit(this.selectedCompany);
    this.graphDataSet = null;
    await this.getSharePrice(value.companyName);
    await this.setOverviewDateOnLoad();
  }

  receivedSparkLineData(data) {
    this.graphDataSet = data;
    this.calculatePercentage();
  }

  calculatePercentage() {
    try {
      let l = this.graphDataSet.data.length;

      let latestPrice = null;
      let previousPrice = null;
      for (let i = l - 1; i >= 0; i--) {
        if (this.graphDataSet.data[i].y) {
          if (!latestPrice) {
            latestPrice = this.graphDataSet.data[i].y;
            continue;
          }
          if (latestPrice) {
            previousPrice = this.graphDataSet.data[i].y;
            break;
          }
        }
      }
      this.priceChange = latestPrice - previousPrice;
      this.priceChangePercentage = (Math.abs(this.priceChange) / previousPrice) * 100;
      this.priceChangePercentage = Number(Number(this.priceChangePercentage).toFixed(2));
      this.priceChange = Number(Number(this.priceChange).toFixed(2));
      this.cdRef.detectChanges();
    } catch (e) {
      console.log(e);
    }
  }

  durationChanged(duration) {
    this.selectedDuration = duration;
    let from = null;
    let d = null;
    switch (duration) {
      case '1W':
        from = moment(new Date()).format('YYYY-MM-DD');
        d = new Date(from);
        d.setDate(d.getDate() - 7);
        this.fromDate = new Date(d);
        break;
      case '1M':
        from = moment(new Date()).format('YYYY-MM-DD');
        d = new Date(from);
        d.setMonth(d.getMonth() - 1);
        this.fromDate = new Date(d);
        break;
      case '6M':
        from = moment(new Date()).format('YYYY-MM-DD');
        d = new Date(from);
        d.setMonth(d.getMonth() - 6);
        this.fromDate = new Date(d);
        break;
      case '1Y':
        from = moment(new Date()).format('YYYY-MM-DD');
        d = new Date(from);
        d.setFullYear(d.getFullYear() - 1);
        this.fromDate = new Date(d);
        break;
      case '3Y':
        from = moment(new Date()).format('YYYY-MM-DD');
        d = new Date(from);
        d.setFullYear(d.getFullYear() - 3);
        this.fromDate = new Date(d);
        break;
      case '5Y':
        from = moment(new Date()).format('YYYY-MM-DD');
        d = new Date(from);
        d.setFullYear(d.getFullYear() - 5);
        this.fromDate = new Date(d);
        break;
    }
  }
}
